import { render } from "./Farms.vue?vue&type=template&id=2c236ffa"
import script from "./Farms.vue?vue&type=script&lang=ts"
export * from "./Farms.vue?vue&type=script&lang=ts"
script.render = render

export default script